import type { AgentOptions } from "@newrelic/browser-agent/loaders/agent";
import { Agent } from "@newrelic/browser-agent/loaders/agent";
import { Ajax } from "@newrelic/browser-agent/features/ajax";
import { GenericEvents } from "@newrelic/browser-agent/features/generic_events";
import { JSErrors } from "@newrelic/browser-agent/features/jserrors";
import { Logging } from "@newrelic/browser-agent/features/logging";
import { Metrics } from "@newrelic/browser-agent/features/metrics";
import { PageViewEvent } from "@newrelic/browser-agent/features/page_view_event";
import { PageViewTiming } from "@newrelic/browser-agent/features/page_view_timing";
import { SessionTrace } from "@newrelic/browser-agent/features/session_trace";
import { SoftNav } from "@newrelic/browser-agent/features/soft_navigations";
import { Spa } from "@newrelic/browser-agent/features/spa";

const BEACON_URL = "bam.nr-data.net";

const options: AgentOptions = {
  init: {
    privacy: { cookies_enabled: true },
    ajax: { deny_list: [BEACON_URL] },
    logging: { enabled: true, autoStart: true },
  },
  info: {
    beacon: BEACON_URL,
    errorBeacon: BEACON_URL,
    licenseKey: import.meta.env.VITE_NEWRELIC_LICENSE_KEY as string,
    applicationID: import.meta.env.VITE_NEWRELIC_APPLICATION_ID as string,
    sa: 1,
  },
  loader_config: {
    accountID: import.meta.env.VITE_NEWRELIC_ACCOUNT_ID as string,
    trustKey: import.meta.env.VITE_NEWRELIC_TRUST_KEY as string,
    agentID: import.meta.env.VITE_NEWRELIC_AGENT_ID as string,
    licenseKey: import.meta.env.VITE_NEWRELIC_LICENSE_KEY as string,
    applicationID: import.meta.env.VITE_NEWRELIC_APPLICATION_ID as string,
  },
  features: [
    Ajax,
    GenericEvents,
    JSErrors,
    Logging,
    Metrics,
    PageViewEvent,
    PageViewTiming,
    SessionTrace,
    SoftNav,
    Spa,
  ],
} satisfies AgentOptions;

const browserAgent = new Agent({ ...options });

export { browserAgent };
